import {v4 as $hgUW1$v4} from "uuid";
import $hgUW1$axios from "axios";

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
//---------------------------------------------------------------------------------
var $f3ad94c9f84f4d57$exports = {};

$parcel$export($f3ad94c9f84f4d57$exports, "logger", () => $f3ad94c9f84f4d57$export$af88d00dbe7f521);
$parcel$export($f3ad94c9f84f4d57$exports, "getLog", () => $f3ad94c9f84f4d57$export$29ce6c7518aa120);
$parcel$export($f3ad94c9f84f4d57$exports, "clearLog", () => $f3ad94c9f84f4d57$export$b3f7b476bfd05092);
//---------------------------------------------------------------------------------
//---------------------------------------------------------------------------------
let $f3ad94c9f84f4d57$var$log = [];
const $f3ad94c9f84f4d57$export$af88d00dbe7f521 = (logEntry, category1, category2, timestamp)=>{
    let entry = {
        l: logEntry,
        c1: category1,
        c2: category2,
        t: timestamp
    };
    $f3ad94c9f84f4d57$var$log.push(entry);
    console.log("Modulo LOG:", entry);
};
const $f3ad94c9f84f4d57$export$29ce6c7518aa120 = (filterFn = ()=>true)=>$f3ad94c9f84f4d57$var$log.filter(filterFn);
const $f3ad94c9f84f4d57$export$b3f7b476bfd05092 = ()=>{
    $f3ad94c9f84f4d57$var$log = [];
}; //---------------------------------------------------------------------------------


var $56f0af142286d4ef$exports = {};
//---------------------------------------------------------------------------------
 //---------------------------------------------------------------------------------


var $509b7546ab31ab1e$exports = {};

$parcel$export($509b7546ab31ab1e$exports, "setModuloId", () => $509b7546ab31ab1e$export$3a70a15c6c545da1);
$parcel$export($509b7546ab31ab1e$exports, "setLogger", () => $509b7546ab31ab1e$export$3abbd92f765bee58);
$parcel$export($509b7546ab31ab1e$exports, "getLogger", () => $509b7546ab31ab1e$export$2b1d391cd05230fd);
$parcel$export($509b7546ab31ab1e$exports, "getActorNames", () => $509b7546ab31ab1e$export$e735f808e3d16a57);
$parcel$export($509b7546ab31ab1e$exports, "actorExists", () => $509b7546ab31ab1e$export$32eacf4546e24bcb);
$parcel$export($509b7546ab31ab1e$exports, "registerActor", () => $509b7546ab31ab1e$export$33d1c86a96aae513);
$parcel$export($509b7546ab31ab1e$exports, "unregisterActor", () => $509b7546ab31ab1e$export$eb17612e9c8a05e8);
$parcel$export($509b7546ab31ab1e$exports, "getData", () => $509b7546ab31ab1e$export$7a171f172be0782e);
$parcel$export($509b7546ab31ab1e$exports, "tell", () => $509b7546ab31ab1e$export$de3113ed932c61ab);
$parcel$export($509b7546ab31ab1e$exports, "sendMessage", () => $509b7546ab31ab1e$export$465cb47180de50f0);
$parcel$export($509b7546ab31ab1e$exports, "ask", () => $509b7546ab31ab1e$export$1b4aee0b51c3def8);
$parcel$export($509b7546ab31ab1e$exports, "listenTo", () => $509b7546ab31ab1e$export$391661b031b686a4);
$parcel$export($509b7546ab31ab1e$exports, "stopListeningTo", () => $509b7546ab31ab1e$export$2e270feede537ce0);
$parcel$export($509b7546ab31ab1e$exports, "resetModulo", () => $509b7546ab31ab1e$export$9c372c639b141a64);
//---------------------------------------------------------------------------------

//---------------------------------------------------------------------------------
const $509b7546ab31ab1e$var$defaultData = {
    id: (0, $hgUW1$v4)(),
    actors: {},
    listeners: {},
    logger: ()=>{}
};
//----------------------------------------------
let $509b7546ab31ab1e$var$data = {
    ...$509b7546ab31ab1e$var$defaultData
};
function $509b7546ab31ab1e$export$3a70a15c6c545da1(id) {
    $509b7546ab31ab1e$var$data.id = id;
}
function $509b7546ab31ab1e$export$3abbd92f765bee58(logger) {
    $509b7546ab31ab1e$var$data.logger = logger;
}
function $509b7546ab31ab1e$export$2b1d391cd05230fd() {
    return $509b7546ab31ab1e$var$data.logger;
}
//----------------------------------------------
function $509b7546ab31ab1e$var$trace(logEntry, category) {
    $509b7546ab31ab1e$var$data.logger(logEntry, category, "modulo", new Date().toUTCString());
}
//----------------------------------------------
function $509b7546ab31ab1e$var$emitEvent(name, event) {
    $509b7546ab31ab1e$var$data.listeners[name]?.forEach((listener)=>listener(event));
}
function $509b7546ab31ab1e$export$e735f808e3d16a57() {
    return Object.keys($509b7546ab31ab1e$var$data.actors).map((name)=>name);
}
function $509b7546ab31ab1e$export$32eacf4546e24bcb(name) {
    return $509b7546ab31ab1e$export$e735f808e3d16a57().includes(name);
}
function $509b7546ab31ab1e$export$33d1c86a96aae513(actor, dontFireEvent = false) {
    const name = actor.getData().name;
    $509b7546ab31ab1e$var$data.actors[name] = actor;
    actor.setEmitter((event)=>$509b7546ab31ab1e$var$emitEvent(name, event));
    if (!dontFireEvent) // Emit events for the benefit of all listeners who are already registered
    $509b7546ab31ab1e$var$emitEvent(name, actor.getEventToEmit());
    $509b7546ab31ab1e$var$trace({
        type: "registration",
        message: `registered actor ${name}`
    }, "info");
}
function $509b7546ab31ab1e$export$eb17612e9c8a05e8(name) {
    delete $509b7546ab31ab1e$var$data.actors[name];
    $509b7546ab31ab1e$var$trace({
        type: "unregistration",
        message: `unregistered actor ${name}`
    }, "info");
}
function $509b7546ab31ab1e$export$7a171f172be0782e(name) {
    return $509b7546ab31ab1e$var$data.actors[name]?.getData();
}
function $509b7546ab31ab1e$export$de3113ed932c61ab(msg) {
    $509b7546ab31ab1e$export$465cb47180de50f0({
        ...msg,
        expectResult: false
    });
}
async function $509b7546ab31ab1e$export$1b4aee0b51c3def8(msg) {
    return $509b7546ab31ab1e$export$465cb47180de50f0({
        ...msg,
        expectResult: true
    });
}
async function $509b7546ab31ab1e$export$465cb47180de50f0(msg) {
    const { from: from , to: to , message: message , expectResult: expectResult  } = msg;
    if (!msg.id) msg.id = (0, $hgUW1$v4)();
    if (!msg.mid) msg.mid = $509b7546ab31ab1e$var$data.id;
    let result = {
        id: msg.id,
        mid: msg.mid,
        from: from,
        to: to,
        message: message
    };
    try {
        $509b7546ab31ab1e$var$trace({
            type: "message",
            from: from,
            to: to,
            message: message,
            id: msg.id,
            mid: msg.mid
        }, "info");
        if (!$509b7546ab31ab1e$export$32eacf4546e24bcb(to)) {
            result.error = "invalid actor";
            result.errorCode = (0, $hgUW1$v4)();
            $509b7546ab31ab1e$var$trace({
                error: result.error,
                from: from,
                to: to,
                message: message,
                id: msg.id,
                mid: msg.mid,
                errorCode: result.errorCode
            }, "error");
        } else if (!$509b7546ab31ab1e$var$data.actors[to].isValidMessage(message)) {
            result.error = "invalid message";
            result.errorCode = (0, $hgUW1$v4)();
            $509b7546ab31ab1e$var$trace({
                error: result.error,
                from: from,
                to: to,
                message: message,
                id: msg.id,
                mid: msg.mid,
                errorCode: result.errorCode
            }, "error");
        } else if (expectResult) {
            let response = await $509b7546ab31ab1e$var$data.actors[to].onMessage(msg) ?? undefined;
            if (response?.error) {
                result.error = response.error;
                result.errorCode = response.errorCode ?? (0, $hgUW1$v4)();
            } else result.payload = response;
        } else $509b7546ab31ab1e$var$data.actors[to].onMessage(msg);
    } catch (error) {
        result.error = error.message;
        result.errorCode = (0, $hgUW1$v4)();
        $509b7546ab31ab1e$var$trace({
            error: error.message,
            errorCode: result.errorCode,
            from: from,
            to: to,
            message: message,
            id: msg.id,
            mid: msg.mid
        }, "exception");
    }
    if (expectResult) {
        $509b7546ab31ab1e$var$trace({
            type: "response",
            from: from,
            to: to,
            message: message,
            id: msg.id,
            mid: msg.mid,
            error: result.error,
            errorCode: result.errorCode
        }, "info");
        return result;
    }
}
function $509b7546ab31ab1e$export$391661b031b686a4(name, listener, dontFireEvent = false) {
    if ($509b7546ab31ab1e$var$data.listeners[name]?.indexOf(listener) < 0) $509b7546ab31ab1e$var$data.listeners[name].push(listener);
    else $509b7546ab31ab1e$var$data.listeners[name] = [
        listener
    ];
    if (!dontFireEvent) // Emit an event only for this listener
    {
        if ($509b7546ab31ab1e$var$data.actors[name]) listener($509b7546ab31ab1e$var$data.actors[name].getEventToEmit());
    }
}
function $509b7546ab31ab1e$export$2e270feede537ce0(name, listener) {
    $509b7546ab31ab1e$var$data.listeners[name] = $509b7546ab31ab1e$var$data.listeners[name].filter((l)=>l !== listener);
}
function $509b7546ab31ab1e$export$9c372c639b141a64() {
    $509b7546ab31ab1e$var$data = {
        ...$509b7546ab31ab1e$var$defaultData
    };
} //---------------------------------------------------------------------------------


var $5b1de2d08c2458d8$exports = {};
//---------------------------------------------------------------------------------
 //---------------------------------------------------------------------------------


var $613d60f8621f781d$exports = {};

$parcel$export($613d60f8621f781d$exports, "StatefulActorInstance", () => $613d60f8621f781d$export$a2513251cc9abf5c);
$parcel$export($613d60f8621f781d$exports, "StatefulActorStateInstance", () => $613d60f8621f781d$export$20d45a40e0cda4a8);
$parcel$export($613d60f8621f781d$exports, "StatefulActorErrorState", () => $613d60f8621f781d$export$b12b153ba7e0e6f9);
$parcel$export($613d60f8621f781d$exports, "createStubActor", () => $613d60f8621f781d$export$671ed866dbe5103b);
$parcel$export($613d60f8621f781d$exports, "RestProxy", () => $613d60f8621f781d$export$b1a6e158b59f87e9);
$parcel$export($613d60f8621f781d$exports, "createRestProxy", () => $613d60f8621f781d$export$3b7336c538cbc718);
//---------------------------------------------------------------------------------


class $613d60f8621f781d$export$a2513251cc9abf5c {
    get state() {
        return this._state;
    }
    get data() {
        return {
            ...this._data
        };
    }
    //----------------------------------------------
    restoreData(data) {
        if (data) Object.keys(data).filter((k)=>![
                "name",
                "state",
                "error",
                "errorCode"
            ].includes(k)).forEach((key)=>{
            this._data[key] = data[key];
        });
    }
    //----------------------------------------------
    /**
     * Sets the states of the actor instance.
     * @param states Array of states
     * @example
     * ```ts
     * class AuthService_State_Start extends StatefulActorStateInstance {
     *  public on: Dictionary<StatefulActorStateEvent> = {
     *    "init": async (input?: KeysAndValues, message?: Message | undefined) => {
     *      // Initialization code goes here
     *    }
     *  }
     * },
     * class AuthService_State_Ready extends StatefulActorStateInstance {
     *  public on: Dictionary<StatefulActorStateEvent> = {
     *    // Message handlers goes here
     *  }
     * },
     * const actor = new StatefulActorInstance("auth-service", {}, true);
     * actor.setAllStates([
     *  new AuthService_State_Start("start", true, actor),
     *  new AuthService_States_Ready("ready", true, actor),
     * ]);
     * ```
     */ setAllStates(states) {
        if (states[0].name !== "start") throw new Error("First state should be named 'start'");
        this.states = states;
        this.statesMap = {};
        this.states.forEach((s)=>{
            this.statesMap[s.name] = s;
        });
    }
    //----------------------------------------------
    listenToActors(actors, dontFireEvent = false) {
        this.listeningTo = actors;
        this.listeningTo.forEach((actor)=>{
            (0, $509b7546ab31ab1e$export$391661b031b686a4)(actor, this.listener, dontFireEvent);
        });
    }
    //----------------------------------------------
    /**
     * Create a stateful actor instance.
     * @param name Name of the actor
     * @param dataDef Default data for the instance
     * @param doesNotSaveState Set this to true if the actor is transient
     * @see {@link setAllStates}
     * @example
     * ```ts
     * const actor = new StatefulActorInstance("auth-service", {}, true);
     * actor.setAllStates([
     *  new AuthService_State_Start("start", true, actor),
     *  new AuthService_States_Ready("ready", true, actor),
     * ]);
     * ```
     */ constructor(name, dataDef, doesNotSaveState = false){
        this._data = {};
        this.saveHandler = ()=>{};
        this.emitter = (event)=>{};
        this.listeningTo = [];
        //----------------------------------------------
        this.getEventToEmit = ()=>({
                name: this.name,
                timestamp: new Date().toUTCString(),
                payload: this.getData()
            });
        //----------------------------------------------
        /**
         * Fetches the data associated with this actor instance.
         * @returns Actor data
         * @example
         * ```ts
         * export interface AuthController_Data {
         *  fullName: string;
         *  token: string;
         * }
         *
         * export function addSessionToken(payload: KeysAndValues): KeysAndValues {
         *  const authData = getData(
         *    "auth-controller"
         *  ) as KeysAndValues as AuthController_Data;
         *  return {
         *    ...payload,
         *    token: authData.token,
         *  };
         * }
         *
         * let result = (await ask({
         *  from: "auth-controller",
         *  to: "auth-service",
         *  message: "update-profile",
         *  payload: addSessionToken({
         *    fullName: input?.fullName,
         *    phone: input?.phone,
         *  }),
         * })) as MessageResponse;
         * ```
         * @see getData() in lib-js-c-modulo
         */ this.getData = ()=>({
                name: this.name,
                state: this._state,
                error: this.error,
                errorCode: this.errorCode,
                ...this._data
            });
        //----------------------------------------------
        this.isValidMessage = (message)=>{
            const currentState = this.statesMap[this._state];
            if (!currentState) return false;
            return Object.keys(currentState.on).includes(message);
        };
        //----------------------------------------------
        this.onMessage = async (message)=>{
            if (!this.isValidMessage(message.message)) throw new Error("invalid message");
            const currentState = this.statesMap[this._state];
            return await currentState.on[message.message](message.payload, message);
        };
        //----------------------------------------------
        this.setEmitter = (emitter)=>this.emitter = emitter;
        //----------------------------------------------
        this.start = (currentData)=>{
            let data;
            if (!this.doesNotSaveState && currentData) {
                if (currentData.name !== this.name) throw new Error("name does not match in supplied current-data");
                this.restoreData(currentData);
                this._state = currentData.state;
                this.emitter(this.getEventToEmit());
            } else {
                data = {
                    ...this.defaultData
                };
                (0, $509b7546ab31ab1e$export$2b1d391cd05230fd)()({
                    type: "start",
                    name: this.name
                }, "info", "modulo", new Date().toUTCString());
                this.gotoState("start", data);
            }
        };
        //----------------------------------------------
        /**
         * Used to transition state. This method, unlike setState() will result in
         * entry() method of the state gettting fired.
         * @param state Name of the new state
         * @param data Data that needs to be changed.
         * @example
         * ```ts
         * class AuthController_State_NotAuthenticated extends StatefulActorStateInstance {
         *  public entry: StatefulActorStateEntry = async (input?: KeysAndValues) => {
         *    // This code here will be executed when gotoState() is invoked
         *  };
         * }
         *
         * this.actor.gotoState(AuthController_States.NotAuthenticated, {
         *  fullName: "Guest",
         *  token: "guest",
         * });
         * ```
         */ this.gotoState = (state, data)=>{
            this.statesMap[state].entry(data);
        };
        //----------------------------------------------
        /**
         * Used to transition state. This method, unlike gotoState()
         * WILL NOT fire the entry() method of the target state.
         * @param state Target state
         * @param data Data that needs to be changed.
         * @example
         * ```ts
         * try {
         *  this.actor.setState("logging-in");
         *  let result = (await ask({
         *    from: "auth-controller",
         *    to: "auth-service",
         *    message: "login",
         *    payload: {
         *      email: input?.email,
         *      password: input?.password,
         *    },
         *  })) as MessageResponse;
         *  if (result?.error) throw new Error(result?.error);
         *  this.actor.gotoState(
         *    "authenticated",
         *    result?.payload
         *  );
         *  return {};
         * } catch (err: any) {
         *  this.actor.gotoState("login-error", {
         *    error: err.message,
         *  });
         *  return { error: err.message };
         * }
         * ```
         */ this.setState = (state, data)=>{
            let prevState = this._state;
            this.restoreData(data);
            this._state = state;
            if (data) {
                if (data.error) this.error = data.error;
                if (data.errorCode) this.errorCode = data.errorCode;
            }
            if (!this.statesMap[this._state].isTransientState && !this.doesNotSaveState) this.saveHandler(this.name, this.getData());
            (0, $509b7546ab31ab1e$export$2b1d391cd05230fd)()({
                type: "state-change",
                name: this.name,
                from: prevState,
                to: state
            }, "info", "modulo", new Date().toUTCString());
            this.emitter(this.getEventToEmit());
        };
        //----------------------------------------------
        this.setSaveActorHandler = (handler)=>{
            this.saveHandler = handler;
        };
        //----------------------------------------------
        this.listener = (event)=>{
            this.statesMap.start.on[`${event.name}/changed`]({
                event: event
            });
        };
        this.name = name;
        this.defaultData = dataDef;
        this._state = "";
        this.states = [];
        this.statesMap = {};
        this.doesNotSaveState = doesNotSaveState;
    }
}
class $613d60f8621f781d$export$20d45a40e0cda4a8 {
    //----------------------------------------------
    constructor(name, /**
     * If true, this state will not be saved. This is used for loading and error states.
     */ isTransientState, actor, on){
        this.entry = (input)=>{
            this.actor.setState(this.name, input);
        };
        this.on = {};
        this.name = name;
        this.isTransientState = isTransientState;
        this.actor = actor;
        if (on) this.on = on;
    }
}
class $613d60f8621f781d$export$b12b153ba7e0e6f9 {
    //----------------------------------------------
    constructor(name, actor, nextState, payload, delayInMilliseconds = 3){
        this.entry = (input)=>{
            this.actor.setState(this.name, input);
            setTimeout(()=>{
                this.actor.gotoState(this.nextState, this.payload);
            }, this.delayInMilliseconds * 1000);
        };
        this.on = {};
        this.name = name;
        this.isTransientState = true;
        this.actor = actor;
        this.nextState = nextState;
        this.payload = payload;
        this.delayInMilliseconds = delayInMilliseconds;
    }
}
function $613d60f8621f781d$export$671ed866dbe5103b(name, events) {
    const stubActor = new $613d60f8621f781d$export$a2513251cc9abf5c(name, {}, true);
    stubActor.setAllStates([
        new $613d60f8621f781d$export$20d45a40e0cda4a8("start", true, stubActor, events)
    ]);
    return stubActor;
}
class $613d60f8621f781d$export$b1a6e158b59f87e9 extends $613d60f8621f781d$export$a2513251cc9abf5c {
    //----------------------------------------------
    constructor(name, baseUrl, httpMethod = {}, httpHeaders = ()=>({}), payload = (input)=>({
            id: input.id,
            from: input.from,
            to: input.to,
            expectResult: input.expectResult,
            payload: input.payload,
            message: input.message,
            mid: input.mid
        })){
        super(name, {}, true);
        //----------------------------------------------
        this.onMessage = async (input)=>{
            let response;
            try {
                response = await (0, $hgUW1$axios)({
                    method: this.httpMethod[input.message] ?? "post",
                    url: `${this.baseUrl}/${input.to}/${input.message}`,
                    data: this.payload(input),
                    headers: {
                        "Content-type": "application/json",
                        Accept: "application/json",
                        ...this.httpHeaders()
                    }
                });
                return response.data.payload;
            } catch (err) {
                if (err.response?.status === 400) return err.response.data;
                else return {
                    error: err.response?.data?.error || "ERROR",
                    errorCode: err.response?.data?.errorCode
                };
            }
        };
        //----------------------------------------------
        this.isValidMessage = (message)=>true;
        this.baseUrl = baseUrl;
        this.httpMethod = httpMethod;
        this.httpHeaders = httpHeaders;
        this.payload = payload;
    }
}
function $613d60f8621f781d$export$3b7336c538cbc718(name, baseUrl, httpMethod = {}, httpHeaders = ()=>({})) {
    const restProxy = new $613d60f8621f781d$export$b1a6e158b59f87e9(name, baseUrl, httpMethod, httpHeaders);
    restProxy.setAllStates([
        new $613d60f8621f781d$export$20d45a40e0cda4a8("start", true, restProxy)
    ]);
    return restProxy;
} //---------------------------------------------------------------------------------


 //---------------------------------------------------------------------------------


export {$f3ad94c9f84f4d57$export$af88d00dbe7f521 as logger, $f3ad94c9f84f4d57$export$29ce6c7518aa120 as getLog, $f3ad94c9f84f4d57$export$b3f7b476bfd05092 as clearLog, $509b7546ab31ab1e$export$3a70a15c6c545da1 as setModuloId, $509b7546ab31ab1e$export$3abbd92f765bee58 as setLogger, $509b7546ab31ab1e$export$2b1d391cd05230fd as getLogger, $509b7546ab31ab1e$export$e735f808e3d16a57 as getActorNames, $509b7546ab31ab1e$export$32eacf4546e24bcb as actorExists, $509b7546ab31ab1e$export$33d1c86a96aae513 as registerActor, $509b7546ab31ab1e$export$eb17612e9c8a05e8 as unregisterActor, $509b7546ab31ab1e$export$7a171f172be0782e as getData, $509b7546ab31ab1e$export$de3113ed932c61ab as tell, $509b7546ab31ab1e$export$465cb47180de50f0 as sendMessage, $509b7546ab31ab1e$export$1b4aee0b51c3def8 as ask, $509b7546ab31ab1e$export$391661b031b686a4 as listenTo, $509b7546ab31ab1e$export$2e270feede537ce0 as stopListeningTo, $509b7546ab31ab1e$export$9c372c639b141a64 as resetModulo, $613d60f8621f781d$export$a2513251cc9abf5c as StatefulActorInstance, $613d60f8621f781d$export$20d45a40e0cda4a8 as StatefulActorStateInstance, $613d60f8621f781d$export$b12b153ba7e0e6f9 as StatefulActorErrorState, $613d60f8621f781d$export$671ed866dbe5103b as createStubActor, $613d60f8621f781d$export$b1a6e158b59f87e9 as RestProxy, $613d60f8621f781d$export$3b7336c538cbc718 as createRestProxy};
//# sourceMappingURL=index.js.map
